import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import GitHubOAuthCompletePage from '@/pages/oauth/github-complete'

const searchSchema = z.object({
  status: z.enum(['success', 'error', 'link_ready']),
  workspaceId: z.string().uuid().optional(),
  message: z.string().optional(),
})

export const Route = createFileRoute('/oauth/github/complete')({
  validateSearch: (search) => searchSchema.parse(search),
  component: GitHubOAuthCompleteRoute,
  staticData: { layout: 'public' },
})

function GitHubOAuthCompleteRoute() {
  const search = Route.useSearch()
  return (
    <GitHubOAuthCompletePage
      status={search.status}
      workspaceId={search.workspaceId}
      message={search.message}
    />
  )
}
